import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'
import TextButton from 'components/Luxkit/Button/TextButton'
import { TourV2ContentSections } from 'constants/tours'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { getIsTourOfferPurchasable } from 'selectors/TourV2/tourV2OfferPageSelectors'
import Caption from 'components/Luxkit/Typography/Caption'
import zIndex from 'styles/tools/z-index'

const FooterWrapper = styled(Pane)`
  bottom: 0;
  box-shadow: ${(props) => props.theme.shadow.top.small};
  display: flex;
  flex-direction: column;
  padding: ${rem(20)} ${rem(16)};
  position: fixed;
  width: 100vw;
  z-index: ${zIndex.stickyFooter};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const ContentContainer = styled.div`
  display: flex;
  gap: ${rem(12)};
  justify-content: space-between;
  align-items: end;
`
interface MappedStateProps {
  isOfferPurchasable: boolean
}

interface Props {
  purchasableOption?: Tours.V2OfferPurchasableOption
  onScrollTo: (section: TourV2ContentSections) => void
  onCheckAvailability: () => void
}

function TourV2StickyFooter(props: Props & MappedStateProps) {
  const { purchasableOption, isOfferPurchasable, onScrollTo, onCheckAvailability } = props

  const purchasableOptionDetails = useTourV2PurchasableOptionDetails(purchasableOption)

  const scrollToDepartures = useCallback(
    () => {
      onCheckAvailability() // Track click on "Check availability" button
      onScrollTo(TourV2ContentSections.DEPARTURES)
    },
    [onScrollTo, onCheckAvailability],
  )

  return (
    <FooterWrapper shadow data-testid="tour-v2-sticky-footer" >
      <ContentContainer>
        {!!purchasableOptionDetails && <div>
          <div>
            <BodyText variant="medium" colour="neutral-one" as="span">
              From{' '}
            </BodyText>
            <Heading variant="heading5" colour="neutral-one" as="span">
              <FormatCurrency value={purchasableOptionDetails.pricePerPerson} format="roundedDollar" />
            </Heading>
            <BodyText variant="medium" as="span">/person</BodyText>
          </div>
          <BodyText variant="small" colour="neutral-two">
            {purchasableOptionDetails.roomTypeName}
          </BodyText>
        </div>}

        {!isOfferPurchasable && <Caption variant="large" weight="bold" format="uppercase" align="center">
          Sold Out
        </Caption>}

        {isOfferPurchasable && <TextButton kind="primary" onClick={scrollToDepartures}>
          Check Availability
        </TextButton>}
      </ContentContainer>
    </FooterWrapper>
  )
}

export default withOfferPageState<MappedStateProps>((offerPageState) => ({
  isOfferPurchasable: getIsTourOfferPurchasable(offerPageState),
}))(TourV2StickyFooter)
